import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/diningApi";

const WaveContext = createContext(null);

export function DiningWaveProvider({ children }) {
  const [waves, setWaves] = useState([]);
  const [currentWaveId, setCurrentWaveIdState] = useState(localStorage.getItem("dining_current_wave_id") || "");
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/waves");
      setWaves(data);
      const stored = localStorage.getItem("dining_current_wave_id");
      const exists = data.find((w) => w.id === stored);
      let chosen;
      if (exists) {
        chosen = stored;
      } else {
        const cur = data.find((w) => w.is_current) || data[0];
        chosen = cur?.id || "";
      }
      if (chosen && chosen !== stored) {
        localStorage.setItem("dining_current_wave_id", chosen);
      }
      setCurrentWaveIdState(chosen);
    } catch {
      // sin sesión / sin permiso; ignorar
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const setCurrentWaveId = (wid) => {
    localStorage.setItem("dining_current_wave_id", wid);
    setCurrentWaveIdState(wid);
    window.dispatchEvent(new CustomEvent("wave-changed", { detail: wid }));
  };

  const currentWave = waves.find((w) => w.id === currentWaveId) || null;

  return (
    <WaveContext.Provider value={{ waves, currentWave, currentWaveId, setCurrentWaveId, refresh, loading }}>
      {children}
    </WaveContext.Provider>
  );
}

export const useWaves = () => useContext(WaveContext);
